import gql from 'graphql-tag';

export const AddSpaceLink = gql`
	mutation SideNavigationAddSpaceLink($id: String!, $spaceKey: String!) @experimental {
		experimentalAddSpaceLink(id: $id, spaceKey: $spaceKey)
	}
`;
